document.addEventListener("DOMContentLoaded", function () {
  let ariaBtn = document.querySelector(".QT4by");
  if (ariaBtn) ariaBtn.setAttribute("aria-label", "More info");

  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;

  const getHeaderOffset = () => {
    const headerSpace = document.querySelector("[data-header-space]");
    if (headerSpace) return headerSpace.offsetHeight || 0;
    return 0;
  };

  const scrollToHash = (hash) => {
    if (!hash || hash === "#") return false;

    const decoded = decodeURIComponent(hash);
    const id = decoded.replace(/^#/, "");
    if (!id) return false;

    const target = document.getElementById(id);
    if (!target) return false;

    const offset = getHeaderOffset();
    const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
    const top = Math.max(0, targetTop - offset - 8);

    window.scrollTo({
      top,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });

    return true;
  };

  const closeDrawerMenu = () => {
    const drawerMenu = document.querySelector("[data-drawer-menu]");
    if (!drawerMenu || !drawerMenu.classList.contains("active")) return false;

    const menuButton = document.querySelector("[data-js-menu-button]");
    if (!menuButton) return false;

    menuButton.click();
    return true;
  };

  document.addEventListener("click", function (event) {
    const anchor = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
    if (!anchor) return;

    const href = anchor.getAttribute("href");
    if (!href || !href.startsWith("#")) return;

    const isDrawerLink = Boolean(anchor.closest("[data-drawer-menu]"));

    if (scrollToHash(href)) {
      event.preventDefault();
      const drawerWasClosed = isDrawerLink && closeDrawerMenu();

      setTimeout(
        () => {
          scrollToHash(href);
          history.pushState(null, "", href);
        },
        drawerWasClosed ? 400 : 0
      );
      return;
    }

    // If the target isn't on this page (e.g. clicked from another template),
    // send them to the shop root with the same hash.
    const root = (window.theme && window.theme.routes && window.theme.routes.root) || "/";
    if (window.location.pathname !== root) {
      event.preventDefault();
      window.location.href = `${root}${href}`;
    }
  });

  // If the page loads with a hash (e.g. /#Bundles), scroll once content is ready.
  const initialHash = window.location.hash;
  if (initialHash) {
    setTimeout(() => scrollToHash(initialHash), 50);
    setTimeout(() => scrollToHash(initialHash), 500);
  }

  let view_rcpt_buttons = document.getElementsByClassName("view_rcpt");

  for (let i = 0; i < view_rcpt_buttons.length; i++) {
    view_rcpt_buttons[i].addEventListener("click", function () {
      const modal_id = this.dataset.modalrcpt;
      const modal = document.getElementById(modal_id);

      if (!modal) return;

      modal.classList.add("active");

      const closeBtn = modal.querySelector(".recipe__overlay a.close");
      if (closeBtn) closeBtn.focus();

      const overlay = modal.querySelector(".recipe__overlay");
      if (overlay) {
        overlay.addEventListener("click", function () {
          modal.classList.remove("active");
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          modal.classList.remove("active");
        });
      }
    });
  }

  setTimeout(function () {
    var sel1 = document.getElementById("Option1");
    var sel2 = document.getElementById("Option2");

    if (sel1 && sel2) {
      sel1.addEventListener("change", changePicklesImage);
      sel2.addEventListener("change", changePicklesImage);
    }
  }, 300);
});
